export default {
  flashes: [],
  paginationFlashes: [],
  keepFlash: false
}



// WEBPACK FOOTER //
// ./src/app/components/shareds/flash/vuex/state.js